import { TablePage, ViewPage, EditPage, AddPage, AdminTablePage, AdminViewPage } from 'src/views/sco-invmgmt/category/index'
import pathMap from 'src/paths/PathMap_SCO_InvMgmt'


class InvCategoryRoute {
    getConfigurations() {
        return [
            {
                exact: true,
                path: pathMap.SCO_INV_CATEGORY_LIST,
                component: TablePage
            },
            {
                exact: true,
                path: pathMap.SCO_INV_CATEGORY_DETAILS_VIEW,
                component: ViewPage
            },
            {
                exact: true,
                path: pathMap.SCO_INV_CATEGORY_EDIT_VIEW,
                component: EditPage
            },
            {
                exact: true,
                path: pathMap.SCO_INV_CATEGORY_CREATE_VIEW,
                component: AddPage
            },
            {
                exact: true,
                path: pathMap.SCO_INV_ADMIN_CATEGORY_LIST,
                component: AdminTablePage
            },
            {
                exact: true,
                path: pathMap.SCO_INV_ADMIN_CATEGORY_DETAILS_VIEW,
                component: AdminViewPage
            },
        ]
    }
}

export default InvCategoryRoute